import { render, staticRenderFns } from "./reset_pwd.vue?vue&type=template&id=9bddef36&scoped=true"
import script from "./reset_pwd.vue?vue&type=script&lang=js"
export * from "./reset_pwd.vue?vue&type=script&lang=js"
import style0 from "./reset_pwd.vue?vue&type=style&index=0&id=9bddef36&prod&scoped=true&lang=css"
import style1 from "./reset_pwd.vue?vue&type=style&index=1&id=9bddef36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bddef36",
  null
  
)

export default component.exports